import { Signal, TemplateRef, inject } from '@angular/core'
import { FormGroup } from '@angular/forms'

import { Observable, first, map, tap } from 'rxjs'

import { FlxModalService } from '@flowx/angular-ui-toolkit'
import { ConfirmationModalComponent } from '@flowx/designer/shared/components/confirmation-modal/confirmation-modal.component'

// Typed by shape rather than by component, so neither configuration page is pulled into the chunk
// the other one lazy loads. `discardDraft` is the page's own, too: the service that owns the form is
// provided on the corrective-actions route component, which a route guard cannot inject.
interface ConfigurationPage {
  canDeactivateConfirmationTRef: Signal<TemplateRef<unknown>>
  discardDraft(): void
}

export const migrationConfigurationCanDeactivate = (
  component: ConfigurationPage & { migrationFG: FormGroup }
): Observable<boolean> | boolean => confirmDiscard(component, component.migrationFG)

export const moveTokenConfigurationCanDeactivate = (
  component: ConfigurationPage & { moveTokenFG: FormGroup }
): Observable<boolean> | boolean => confirmDiscard(component, component.moveTokenFG)

// Called straight from the guards so `inject` still runs inside their injection context.
const confirmDiscard = (
  component: ConfigurationPage,
  configurationFG: FormGroup
): Observable<boolean> | boolean => {
  if (configurationFG.pristine) {
    return true
  }

  const modalService = inject(FlxModalService)
  const canDeactivateConfirmationTRef = component.canDeactivateConfirmationTRef()

  return modalService
    .show(
      ConfirmationModalComponent,
      { closeOnBackdropClick: false, backdropClass: 'overlay-backdrop' },
      {
        customTemplate: canDeactivateConfirmationTRef,
        btnOkText: `Discard`,
      }
    )
    .data$.pipe(
      first(),
      map(({ confirm }) => confirm),
      tap((confirm) => {
        if (confirm) {
          component.discardDraft()
        }
      })
    )
}
